<a
  [href]="link"
  target="_blank"
  rel="noopener"
  class="fixed bottom-6 right-6 w-16 h-16 bg-whatsapp-green text-white rounded-full flex items-center justify-center shadow-2xl z-40 pulse-whatsapp hover:scale-110 active:scale-90 transition-transform"
  aria-label="Empieza por WhatsApp"
>
  <img src="assets/icons/whatsapp-icon.png" alt="WhatsApp" width="32" height="30" class="w-8 h-auto">
</a>
